import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ShopifyProduct } from '@/lib/shopify';

interface WishlistStore {
  items: ShopifyProduct[];
  
  // Actions
  addItem: (product: ShopifyProduct) => void;
  removeItem: (productId: string) => void;
  isInWishlist: (productId: string) => boolean;
  toggleItem: (product: ShopifyProduct) => void;
  clearWishlist: () => void;
  getCount: () => number;
}

export const useWishlistStore = create<WishlistStore>()(
  persist(
    (set, get) => ({
      items: [],

      addItem: (product) => {
        const { items } = get();
        if (!items.find(item => item.node.id === product.node.id)) {
          set({ items: [...items, product] });
        }
      },

      removeItem: (productId) => {
        set({
          items: get().items.filter(item => item.node.id !== productId)
        });
      },

      isInWishlist: (productId) => {
        return get().items.some(item => item.node.id === productId);
      },

      toggleItem: (product) => {
        const { items, addItem, removeItem } = get();
        const exists = items.find(item => item.node.id === product.node.id);
        
        if (exists) {
          removeItem(product.node.id);
        } else {
          addItem(product);
        }
      },

      clearWishlist: () => {
        set({ items: [] });
      },

      getCount: () => {
        return get().items.length;
      },
    }),
    {
      name: 'calimstyle-wishlist',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
